var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0",staticStyle:{"margin":"0px"}})}
var staticRenderFns = []

export { render, staticRenderFns }